import { z } from 'zod';

export const PostDeleteFiatBankAccountResultSchema = z.object({
  code: z.number(),
});

export type PostDeleteFiatBankAccountResult = z.infer<
  typeof PostDeleteFiatBankAccountResultSchema
>;

export type PostDeleteFiatBankAccountParams = string;
